import loginRoute from "pages/Login/route"

export default [loginRoute];